import {
    createBaseThemeOptions,
    createUnifiedTheme,
    defaultTypography,
    palettes,
    UnifiedTheme,
} from '@backstage/theme';


const sidebarOpenWidth = 18;  // [rem]
const sidebarClosedWidth = 6;  // [rem]


function createCaiseTheme(options: {
    basePalette: any;
    backgroundColor: string,
    paperColor: string,
    navigationColor: string,
    hoverColor: string,
    headerColors: string[]
}): UnifiedTheme {
    return createUnifiedTheme({
        ...createBaseThemeOptions({
            palette: {
                ...options.basePalette,
                background: {
                    default: options.backgroundColor,
                    paper: options.paperColor,
                },
                navigation: {
                    ...options.basePalette.navigation,
                    color: '#b8d0e7',
                    background: options.navigationColor,
                    //indicator: '#5ec348',
                    indicator: '#0e151d',
                    navItem: {
                        hoverBackground: options.hoverColor,
                    },
                },
            },
            typography: {
                ...defaultTypography,
                fontFamily: '"Poppins", Helvetica, Arial, Lucida, sans-serif',
            }
        }),
        components: {
            BackstageHeader: {
                styleOverrides: {
                    header: () => ({
                        marginBottom: '0.5rem',
                        margin: '0',
                        padding: '0',
                        boxShadow: 'none',
                        backgroundImage: 'none',
                        '& h1': {
                            fontWeight: 500,
                            backgroundImage: 'linear-gradient(27deg,#2353a5 4.5%,#0cabf3 16.7%,#0fa0e9 35%,#2353a5 42.5%)',  // halved due to full-screen width of the header
                            color: 'transparent',
                            backgroundClip: 'text',
                            letterSpacing: '-0.05em',
                            fontSize: 'clamp(2.25rem,4.1vw,3.125rem)',
                            lineHeight: 'initial',
                        },
                    }),
                    'type': {
                        display: 'none',
                    },
                    rightItemsBox: {
                        display: 'none',
                    },
                },
            },
            BackstageSidebarPage: {
                styleOverrides: {
                    root: ({theme}) => ({
                        [theme.breakpoints.up("sm")]: {
                            // @ts-ignore
                            paddingLeft: (props) => (
                                props.isPinned
                                    ? `${sidebarOpenWidth + 4}rem`
                                    : `${sidebarClosedWidth + 4}rem`
                            ),
                        },
                        /*
                        [theme.breakpoints.down("xs")]: {
                            paddingBottom: (props) => props.sidebarConfig.mobileSidebarHeight
                        },
                        */
                    }),
                },
            },
            BackstageSidebar: {
                styleOverrides: {
                    // @ts-ignore
                    root: {
                        margin: '2rem 0 2rem 2rem',
                    },
                    drawer: {
                        borderRadius: '1.25rem',
                        padding: '1.25rem 1rem',
                        backgroundColor: '#0e151d',
                    },
                },
            },
            BackstageSidebarItem: {
                styleOverrides: {
                    root: {
                        color: 'rgb(12, 171, 243)',
                        '&:hover': {
                            color: 'rgb(239, 242, 244)',
                            // color: '#64748b',  // WCAG?
                        },
                    },
                    closed: {
                        width: '4rem !important',
                    },
                    iconContainer: {
                        width: '4rem',
                    },
                    label: {
                        paddingLeft: '0rem',
                    },
                    highlightable: {
                        '&:hover': {
                            background: 'initial',
                        },
                    },
                },
            },
            BackstagePage: {
                styleOverrides: {
                    root: {
                        paddingTop: '2rem',
                        paddingBottom: '2rem',
                        paddingRight: '2rem',
                    },
                },
            },
            BackstageContent: {
                styleOverrides: {
                    root: {
                        marginTop: '3rem',
                        padding: '0 !important',
                    },
                },
            },
            BackstageTable: {
                styleOverrides: {
                    root: {
                        '& > div': {
                            borderRadius: '1rem',
                            boxShadow: 'none',
                        },
                        '& tfoot tr': {
                            borderBottomLeftRadius: '1rem',
                            borderBottomRightRadius: '1rem',
                        },
                    },
                },
            },
            BackstageTableToolbar: {
                styleOverrides: {
                    root: {
                        padding: '0.625rem 0.625rem 0.625rem 1.25rem',
                        color: 'white',
                        textAlign: 'left',
                        backgroundColor: '#0d151d',
                        borderTopLeftRadius: '1rem',
                        borderTopRightRadius: '1rem',
                        minHeight: 'initial',
                        '& h2': {
                            fontWeight: 500,
                            fontSize: 'clamp(1rem, 1.2vw, 1.125rem) !important',
                            letterSpacing: '-0.05rem',
                            padding: 0,
                            margin: 0,
                        },
                    },
                },
            },
        },
    });
}

export const caiseLightTheme = createCaiseTheme({
    basePalette: palettes.light,
    backgroundColor: palettes.light.background.default,
    paperColor: palettes.light.background.paper,
    navigationColor: '#003767',
    hoverColor: '#275c8c',
    headerColors: ['#1d5280', '#275c8c'],
});
